import { IntakeFormResult } from '@sweatpals/react-ui-kit';

export enum DonationTierEnum {
	HigherPrice = 'higher-price',
	MediumPrice = 'medium-price',
	LowPrice = 'low-price',
	CustomPrice = 'custom-price',
}

export interface DonationTierDto {
	id: DonationTierEnum;
	amount: number;
}

export interface IntakeFormDto {
	isPrefilled: boolean;
	result: IntakeFormResult;
}

export interface EventPricesStepsDto {
	[key: string]: {
		firstStep: number;
		lastStep: number;
	}
}

export interface CheckoutFormDto {
	fullName: string;
	email: string;
	phone: string;
	code?: string;
	intakeForms?: IntakeFormDto[];
	recaptchaTokenV2?: string;
	recaptchaTokenV3?: string;
	e2eToken?: string;
}
